import { createInsertSchema, createSelectSchema } from "drizzle-zod";
import { z } from "zod";
import { taskStepTypesLinks } from "../drizzle/taskStepTypesLinks.js";
export const taskStepTypesLinkSchema = createSelectSchema(taskStepTypesLinks, {
    // Use z.coerce.date() for date fields because JSON serialization converts Date objects to ISO strings
    createdAt: () => z.coerce.date().meta({
        description: "Link creation timestamp",
        example: "2024-01-15T10:30:00.000Z",
    }),
    updatedAt: () => z.coerce.date().meta({
        description: "Link last update timestamp",
        example: "2024-01-15T10:30:00.000Z",
    }),
    taskType: (schema) => schema.meta({
        description: "Task type key (part of composite primary key)",
        example: "cost_estimate",
    }),
    stepType: (schema) => schema.meta({
        description: "Step type key (part of composite primary key)",
        example: "cost_estimate_check",
    }),
    orderNumber: (schema) => schema.meta({
        description: "Order number of the step within the task type",
        example: 1,
    }),
}).describe("Task-Step type link object");
export const createTaskStepTypesLinkSchema = createInsertSchema(taskStepTypesLinks, {
    taskType: (schema) => schema.meta({
        description: "Task type key",
        example: "cost_estimate",
    }),
    stepType: (schema) => schema.meta({
        description: "Step type key",
        example: "cost_estimate_check",
    }),
    orderNumber: (schema) => schema.meta({
        description: "Order number of the step within the task type",
        example: 1,
    }),
}).describe("Create task-step type link request body");
